import {
  Grid,
  Typography,
  Link,
  ListItem,
  Button,
  Box,
} from '@mui/material';
import { BusinessCenter, Groups } from '@mui/icons-material';

import { UserTypes } from '../../../../config/enums';
import { setUserType, useLoginState } from '../../../../hooks/loginInfo';
import Avatar from '../../../../pages/components/avatar';
import { useUserInfoState } from '../../../../hooks/userInfo';
import { theme } from '../../..';

const UserInfoContent = () => {
  const userInfoState = useUserInfoState();
  const loginState = useLoginState();
  const infoUser = userInfoState.get();
  const userType = loginState.user_type.get();
  const href = infoUser?.company?.id ? '/company/settings' : '/person/settings';
  const userTypeValue = loginState.user_type.get();
  const activeProducer = userTypeValue === UserTypes.PRODUCER ? 'primary' : 'white'
  const activeCrewMember = userTypeValue === UserTypes.CREW_MEMBER ? 'primary' : 'white'

  return (
    <>
      {
        infoUser && (
          <Grid
            sx={{
              width: '100%',
              mt: 4,
              textAlign: 'center',
            }}
          >
            <Avatar url={userInfoState.get().company?.url_file || userInfoState.get().user?.url_avatar} size={100} />
            <Typography
              sx={{
                mt: 1,
                color: 'white',
                fontWeight: 500,
              }}
              component="p"
              variant="h3"
            >
              {infoUser?.company?.company_name || infoUser?.user?.full_name}
            </Typography>
            <Typography
              sx={{
                m: 0,
                color: theme.palette.primary.main,
                fontWeight: 500,
              }}
              component="p"
              variant="body2"
            >
              {infoUser?.company?.company_name ? 'Company' : infoUser?.user?.job_title?.name || 'Person'}
            </Typography>
            <Link
              sx={{
                display: 'block',
                mt: 2,
                color: 'white',
                fontSize: 10,
                textDecoration: 'underline',
                fontWeight: 300
              }}
              href={href}
            >
              Edit information
            </Link>

            <Grid
              sx={{
                mt: 4,
              }}
            >
              <ListItem
                disableGutters
                sx={{
                  display: 'flex',
                  width: '90%',
                  mb: 0.5,
                  p: 0,
                }}
              >
                <Button
                  startIcon={(<BusinessCenter fontSize="small" />)}
                  disableRipple
                  onClick={() => {
                    if (userType !== UserTypes.PRODUCER) {
                      setUserType(UserTypes.PRODUCER)
                    }
                  }}
                  sx={{
                    color: activeProducer,
                    justifyContent: 'flex-start',
                    px: 2,
                    py: 0,
                    m: 0,
                    textAlign: 'left',
                    textTransform: 'none',
                    width: '100%',
                    '& .MuiButton-startIcon': {
                      color: activeProducer,
                    },
                    '.Mui-disabled': {
                      color: '#fffff',
                      background: '#00000',
                    },
                    '&:hover': {
                      color: 'primary',
                      background: 'none',
                    },
                  }}
                >
                  <Box sx={{ flexGrow: 1, fontWeight: 500, fontSize: '12px' }}>
                    Producer
                  </Box>
                </Button>
                <Typography
                  sx={{
                    m: 0,
                    color: activeProducer === 'primary' ? theme.palette.primary.main : theme.palette.background.paper,
                    fontWeight: 500,
                    fontSize: '12px'
                  }}
                  component="p"
                  variant="body2"
                >
                  {infoUser?.producers_projects}
                </Typography>
              </ListItem>
              {
                !infoUser.company && (
                  <ListItem
                    disableGutters
                    sx={{
                      display: 'flex',
                      width: '90%',
                      mb: 0.5,
                      p: 0,
                    }}
                  >
                    <Button
                      component="a"
                      startIcon={(<Groups fontSize="small" />)}
                      disableRipple
                      onClick={() => {
                        if (userType !== UserTypes.CREW_MEMBER) {
                          setUserType(UserTypes.CREW_MEMBER)
                        }
                      }}
                      sx={{
                        color: activeCrewMember,
                        justifyContent: 'flex-start',
                        px: 2,
                        py: 0,
                        m: 0,
                        textAlign: 'left',
                        textTransform: 'none',
                        width: '100%',
                        '& .MuiButton-startIcon': {
                          color: activeCrewMember,
                        },
                        '&:hover': {
                          color: 'primary',
                          background: 'none',
                        },
                      }}
                    >
                      <Box sx={{ flexGrow: 1, fontWeight: 500, fontSize: '12px' }}>
                        Crew Member
                      </Box>
                    </Button>
                    <Typography
                      sx={{
                        m: 0,
                        color: activeCrewMember === 'primary' ? '#FEB100' : '#FFF',
                        fontWeight: 500,
                        fontSize: '12px'
                      }}
                      component="p"
                      variant="body2"
                    >
                      {infoUser?.crew_members_projects}
                    </Typography>
                  </ListItem>
                )
              }
            </Grid>
          </Grid>
        )
      }
    </>
  )
}

export default UserInfoContent;
